module.exports = __webpack_public_path__ + "img/frame (193).a615adbf.jpg";